import AOS from 'aos';
AOS.init();


import "../node_modules/@glidejs/glide/src/assets/sass/glide.core.scss";

// Import theme js
import "./js/custom.js";
import "./js/sidenavigation.js";
import "./js/accordion.js";

// Import theme styles
import "./scss/styles.scss";
